import { Auth } from "aws-amplify";
import { createAsyncThunk } from "@reduxjs/toolkit";

import { CognitoData } from "./model";
import ApiUser from "integration/api/ApiUser";
import { setNotify } from "common/notify/slice";
import { UserStatusEnum } from "integration/api/ApiUser/types";
import { ResponseHandlerName } from "common/responseHandlerService/model";

class AuthActions {
  static generateCognitoData = async () => {
    const response = await Auth.currentSession();
    const payload = response.getIdToken().payload;
    const token = response.getAccessToken().getJwtToken();

    return {
      token,
      email: payload.email,
      given_name: payload.given_name,
      family_name: payload.family_name,
      "custom:mfru_user_id": payload["custom:mfru_user_id"],
    } as CognitoData;
  };

  static onLoad = createAsyncThunk(
    `auth/${ResponseHandlerName.OnLoad}`,
    async (_, { rejectWithValue }) => {
      try {
        const cognitoData = await AuthActions.generateCognitoData();
        const {
          data: { userStatus },
        } = await ApiUser.getUserInfo(cognitoData["custom:mfru_user_id"]);

        return { cognitoData, userStatus };
      } catch (error) {
        console.log("onLoad Error: ", error);
        return rejectWithValue(error);
      }
    }
  );

  static singIn = createAsyncThunk(
    `auth/${ResponseHandlerName.SignIn}`,
    async (
      { email, password }: { email: string; password: string },
      { rejectWithValue, dispatch }
    ) => {
      try {
        const response = await Auth.signIn(email, password);
        const cognitoData = await AuthActions.generateCognitoData();
        const {
          data: { userStatus },
        } = await ApiUser.getUserInfo(cognitoData["custom:mfru_user_id"]);

        // Show success sign in message
        if (userStatus === UserStatusEnum.ACTIVE) {
          dispatch(
            setNotify({
              visible: true,
              type: "success",
              text: "Success sign",
            })
          );
        } else {
          dispatch(
            setNotify({
              visible: true,
              type: "error",
              text: "Access Denied",
            })
          );
        }

        return { cognitoData, userStatus };
      } catch (error) {
        await Auth.signOut();
        console.log("singIn Error: ", error);
        return rejectWithValue(error);
      }
    }
  );

  static signOut = createAsyncThunk(
    `auth/${ResponseHandlerName.SignOut}`,
    async () => {
      return Auth.signOut();
    }
  );
}

export default AuthActions;
